import React from 'react'
import Img from 'gatsby-image'
import cc from 'classcat'

import s from './styles.module.css'

const LandingSection = ({ className, title, subtitle, image }) => (
  <section className={cc([s.landingSection, className])}>
    <h1 className={s.title}>{title}</h1>
    <h4 className={s.subtitle}>{subtitle}</h4>
    {image ? (
      <Img
        outerWrapperClassName={s.imageWrapper}
        className={s.image}
        sizes={image.sizes}
        alt={title}
      />
    ) : null}
  </section>
)

export default LandingSection



// WEBPACK FOOTER //
// ./src/components/LandingSection/index.js